import { useCallback, useMemo } from "react"
import { useParams, useSearchParams } from "react-router-dom"
import { useQueryWithEndpoint } from "@hydrologiq/shared/hooks/useGraphQLClient"
import { GetAssetAlertsDocument } from "@hydrologiq/gql-experience/graphql"
import { AlertsKanbanView } from "@hydrologiq/shared/components/kanban"
import type { AlertsKanbanData } from "@hydrologiq/shared/components/kanban"

function AssetAlerts() {
  const { assetId } = useParams<{ assetId: string }>()
  const [searchParams, setSearchParams] = useSearchParams()
  const highlightParam = searchParams.get("highlight")

  const { data: rawData, loading, error } = useQueryWithEndpoint(
    GetAssetAlertsDocument,
    {
      variables: { assetId: assetId! },
      notifyOnNetworkStatusChange: false,
      pollInterval: 60000,
      skip: !assetId,
    },
    "primary",
  )

  const data = rawData?.getAssetAlerts as AlertsKanbanData | undefined
  const highlightedAlertId = useMemo(() => highlightParam || undefined, [highlightParam])
  const handleHighlightDismiss = useCallback(() => setSearchParams({}), [setSearchParams])

  return (
    <AlertsKanbanView
      data={data}
      loading={loading}
      error={error}
      assetView={true}
      highlightedAlertId={highlightedAlertId}
      onHighlightDismiss={handleHighlightDismiss}
    />
  )
}

export default AssetAlerts
